(function () {
  const MOBILE_BREAKPOINT = 768;

  class DualStickyScroll {
    constructor(container) {
      this.container = container;
      this.columns = [container.children[0], container.children[1]];
      this.lastScrollY = window.scrollY;
      this.tops = [0, 0];
      this.active = false;
      this._onScroll = this.update.bind(this);
      this._onResize = this.handleResize.bind(this);
    }

    getHeaderOffset() {
      const header = document.getElementById("header");
      if (
        header &&
        header.classList.contains("scrolled") &&
        header.classList.contains("show")
      ) {
        return header.offsetHeight || 0;
      }
      return 0;
    }

    init() {
      window.addEventListener("scroll", this._onScroll, { passive: true });
      window.addEventListener("resize", this._onResize);
      this.handleResize();
    }

    activate() {
      if (this.active) return;
      this.active = true;
      this.columns.forEach((col) => {
        col.style.position = "sticky";
        col.style.alignSelf = "start";
      });
      this.lastScrollY = window.scrollY;
      this.tops = [0, 0];
      this.update();
    }

    deactivate() {
      if (!this.active) return;
      this.active = false;
      this.columns.forEach((col) => {
        col.style.position = "";
        col.style.top = "";
        col.style.alignSelf = "";
      });
    }

    handleResize() {
      if (window.innerWidth > MOBILE_BREAKPOINT) {
        this.activate();
      } else {
        this.deactivate();
      }
    }

    update() {
      if (!this.active) return;

      const scrollY = window.scrollY;
      const delta = scrollY - this.lastScrollY;
      const vh = window.innerHeight;
      const headerOffset = this.getHeaderOffset();

      this.columns.forEach((col, i) => {
        const h = col.offsetHeight;

        if (h <= vh - headerOffset) {
          col.style.top = `${headerOffset}px`;
          this.tops[i] = headerOffset;
          return;
        }

        let newTop = this.tops[i] - delta;
        const minTop = vh - h;
        const maxTop = headerOffset;

        newTop = Math.max(minTop, Math.min(maxTop, newTop));

        this.tops[i] = newTop;
        col.style.top = `${newTop}px`;
      });

      this.lastScrollY = scrollY;
    }

    destroy() {
      window.removeEventListener("scroll", this._onScroll);
      window.removeEventListener("resize", this._onResize);
      this.deactivate();
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll("[data-dual-sticky]")
      .forEach((grid) => {
        if (grid.children.length >= 2) {
          const instance = new DualStickyScroll(grid);
          instance.init();
        }
      });
  });
})();
